import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=611c1642&"
import script from "./DashBoard.vue?vue&type=script&lang=js&"
export * from "./DashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports